import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'SET_COLUMN_ORDER',
	'SET_COLUMN_SIZES',
	'SET_COLUMN_SORTING',
	'SET_COLUMNS'
);
